<template>
    <div class="all-order">
        <div class="all-order-content">

            <template v-if="list2 && list2.length">
                <el-table :data="list2" style="width: 100%" row-key="id" :stripe="true" border
                    :tree-props="{ children: 'childrens', hasChildren: 'hasChildren' }"
                    :header-cell-style="{ background: '#fafafa', color: '#333' }">
                    <el-table-column prop="name" label="名称" align="center" />
                    <el-table-column prop="name" label="操作" align="center">
                        <template slot-scope="scope">
                            <span v-if="scope.row.templateFileUrl && scope.row.isUpload && scope.row.flg"
                                @click="downloadBnt(scope.row.templateFileUrl)" class="lookClass"
                                style="margin-left: 0px;">查看</span>
                            <span v-else class="lookClass" style="color:#909399;cursor:not-allowed ;">查看</span>

                        </template>
                    </el-table-column>

                </el-table>
            </template>

            <div class="u-empty" v-else>
                <el-empty description="展商还未提交此内容">
                    <p>截止时间为：{{ timeValue }}，可提醒展商及时提交信息</p>
                </el-empty>
            </div>
        </div>
    </div>
</template>

<script>
import { mapGetters, mapActions, mapMutations } from "vuex";

export default {
    name: "all-order",
    props: {
        timeValue: String
    },
    data () {
        return {
            list: [],
            list2: []

        }
    },
    computed: {
        ...mapGetters({
            formHeaders: "getFormHeaders",
            uploadUrl: "getUploadUrl",
            joinInfo: "loginModule/getJoinInfo",
            company: "loginModule/getCompany",
            exhibition: "loginModule/getExhibition",

            exhibitor: "loginModule/getExhibitor",
        }),
        queryId () {
            return this.$route.query.id;
        },

    },
    mounted () {
        this.proDataList()
    },
    methods: {
        ...mapActions({
            setManageSettingQ: 'hostSetModule/setManageSettingQ', //获取
            totalList: 'exhibitionModule/totalList', //获取统计状态
            receiptGet: "hostSetModule/receiptGet",
            uploadReceiptrecord: "exhibitionModule/uploadReceiptrecord",//上传
            getReceiptrecord: "exhibitionModule/getReceiptrecord",//获取回执上传 状态
        }),
        goDetail () {
            this.$router.push('/exhibition/index/order/detail-order');
        },
        //获取回执表
        async proDataList () {
            let res = await this.receiptGet()
            console.log(res, 12312312);
            if (res) {
             
                let res1 = await this.getReceiptrecord(this.queryId) //获取回执状态
                if (res1) {

                    res1.forEach(item => {
                        res.forEach(item1 => {
                            if (item.itemId == item1.id) {
                                item1.flg = true
                            }
                        })
                    })

                }
                this.list2 =   res.filter(item => {
                    return item.isUpload
                })
            //   res
            }
        },
        downloadBnt (e) {  //下载

            window.open(e, '_blank')

        },

    }
}
</script>

<style lang="scss" scoped>
.all-order {
    min-width: 1000px;
    padding: 30px;
    min-height: 500px;

    &-content {
        background: #FFF;

        .goods {
            width: 18%;
            padding: 10% 0;
            display: inline-block;
            position: relative;
            margin: 0 3px;

            img {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                max-width: 100%;
                max-height: 100%;
                margin: auto;
            }
        }

        .goods-e {
            position: absolute;
            left: 100%;
            top: 30%;
            font-weight: bold;
        }

        .operation {
            color: #1890ff;
            cursor: pointer;
        }
    }
}

/deep/ .el-descriptions__body .el-descriptions__table {
    margin: 30px;
}
</style>